import { render, staticRenderFns } from "./InstagramIconWhite.vue?vue&type=template&id=6d450dd5&scoped=true"
import script from "./InstagramIconWhite.vue?vue&type=script&lang=ts"
export * from "./InstagramIconWhite.vue?vue&type=script&lang=ts"
import style0 from "./InstagramIconWhite.vue?vue&type=style&index=0&id=6d450dd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d450dd5",
  null
  
)

export default component.exports